import React from "react";
import {
  Cloud12,
  HorizontalBarChart12,
  Kpi,
  PictureWall,
  Pies2,
} from "./charts";

export const BrandsOverview = () => (
  <svg viewBox="0 0 108 136">
    <Kpi x={8} y={8} />
    <Kpi x={40} y={8} />
    <Kpi x={72} y={8} />

    <PictureWall x={8} y={28} />

    <HorizontalBarChart12 x={8} y={62} />
    <HorizontalBarChart12 x={56} y={62} />

    <Cloud12 x={8} y={94} />
    <Cloud12 x={56} y={94} />

    <Pies2 x={8} y={126} />
  </svg>
);
